import colors from 'colors'
import Button from 'components/Button'
import { Corner2 } from 'components/Corner'
import { EXCHAGES_INTRO_URL, RESULTS } from 'consts'
import React, { FC } from 'react'
import { animated } from 'react-spring'
import styled from 'styled-components'
import { Leaf } from 'types'
import { useFadeIn } from 'utils/hooks'

import ExchangeList from './ExchangeList'
import Top from './Top'

const Container = styled(animated.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Prompt = styled.div`
  color: ${colors.darkBeige};
`
const Link = styled(Button)`
  margin: 8px 0;
  width: 262px;
  font-size: 12px;
`

interface Props {
  tree: Leaf
  onPressBackToIntro: () => void
}

const Result: FC<Props> = ({ tree, onPressBackToIntro }) => {
  const code = tree.value
  const result = RESULTS[code]
  const anim = useFadeIn()
  return (
    <Container style={anim}>
      <Corner2 />
      <Prompt>- あなたの投資タイプは -</Prompt>
      <Top code={code} result={result} />
      <ExchangeList result={result} />
      <Link onClick={() => window.open(EXCHAGES_INTRO_URL, '_blank')}>
        手数料ランキング
      </Link>
      <Link onClick={onPressBackToIntro}>最初に戻る</Link>
    </Container>
  )
}

export default Result
